/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneFooter from 'sites/allas/components/standalone/Footer';

export const DynamicStandaloneFooter = StandaloneFooter;
export type DynamicStandaloneFooterProps = PropsFromComponent<typeof StandaloneFooter>;

export const DynamicStandaloneFooterWith = (extras: DynamicStandaloneExtras): typeof StandaloneFooter => {
    return function DynamicStandaloneFooter(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Footer');
        return <StandaloneFooter {...mergeProps({ options: { theme } }, props)} />;
    }
}